import { render, staticRenderFns } from "./FreeStatistics.vue?vue&type=template&id=687be80b&scoped=true&lang=html"
import script from "./FreeStatistics.vue?vue&type=script&lang=js"
export * from "./FreeStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687be80b",
  null
  
)

export default component.exports